<script>
  import { derived } from "svelte/store"
  import TableAreaRow from "../../../components/chart/TableAreaRow.svelte";

  export let store;
  export let columnTitle

  const {DisplayedRowCount, RowsCurrentlyDisplayed} = store;

  const rows = derived([RowsCurrentlyDisplayed, DisplayedRowCount], ([RowsCurrentlyDisplayed, DisplayedRowCount]) => {
    /**
     * @type {{
     *   [oroginalRowIndex: number]: number // block height
     * }}
     */
    const heights = {};

    let i = 0
    while (i < RowsCurrentlyDisplayed.length) {
      const row = RowsCurrentlyDisplayed[i];

      let j = i
      while (j < RowsCurrentlyDisplayed.length) {
        if (RowsCurrentlyDisplayed[j].originalData[columnTitle] !== row.originalData[columnTitle]) break
        j++
      }
      heights[i] = j - i
      i = j
    }

    const intrinsicHeightInPercentage = DisplayedRowCount > 0 ? 100 / DisplayedRowCount : 100;
    let cumulativeHeightInPercentage = 0;
    return Object.keys(heights).map(rowIndex => {
      const height = heights[rowIndex] * intrinsicHeightInPercentage;
      cumulativeHeightInPercentage += height;
      return {
        Title: RowsCurrentlyDisplayed[rowIndex].originalData[columnTitle],
        Color: "#E9E9F0",
        Height: height,
        OriginY: cumulativeHeightInPercentage - height,
      };
    });
  });
</script>

{#each $rows as row}
  <g style="cursor: pointer;" class="container">
    <TableAreaRow
      Row={row.Title}
      Color={row === null ? "white" : row.Color}
      IsNull={row === null || row.Height === 0}
      Height={row.Height}
      OriginY={row.OriginY}
    />
  </g>
{/each}

<style>
  /* Ensure the container allows overflow */
  .container {
    position: relative;
    overflow: visible; /* Allow line to exceed container's bounds */
  }
</style>
